import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { FingerModel } from '../authentication-rnec/finger.model';
import { GoogleTagManagerService } from '../shared/google-tag-manager.service';
import { FingerprintUtil } from '../shared/util/FingerprintUtil';
import { RnecAgentModel } from './model/RnecAgent.model';
import { IDataCaptureFingerprint } from './Interface/Responses/IDataCaptureFingerprint';
import { RedirectService } from '../shared/redirect.service';
import { RNECEventEnum } from '../authentication-rnec/authentication-rnec.enum';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { EventsService } from '../shared/bdb-event.service';
import { IResponseAgent } from './Interface/Responses/IResponseAgent';
import { BdbDialogoComponent } from '../../webcomponents/bdb-dialogo/bdb-dialogo.component';
import { NewServiceErrorEnum } from '../enums/new-service-error.enum';
import { CustomLogger } from '@npm-bbta/bbog-sg-frontend-logs-lib';
import { BdbErrorV2ModalComponent } from '../bdb-error-v2-modal/bdb-error-v2-modal.component';
import { ErrorCode } from '../models/error-codes-v2';

const logger = new CustomLogger('app-authentication-rnec-v2', 'green');

@Component({
    selector: 'app-authentication-rnec-v2',
    templateUrl: './authentication-rnec-v2.component.html',
    styleUrls: ['./authentication-rnec-v2.component.scss']
})
export class AuthenticationRnecV2Component implements OnInit {
    @ViewChild('loader') loaderBdb: ElementRef;
    @ViewChild('modal') modalBdb: ElementRef;
    modalFunctionYes: Function;

    @ViewChild('errorAgentConexion') errorAgentConexion: BdbDialogoComponent;
    @ViewChild(BdbErrorV2ModalComponent) errorModal: BdbErrorV2ModalComponent;

    @Input() buttonText = 'Comenzar ›';
    @Input() successFingerprint = false;
    @Input() fingerNameClass = '';
    @Input() capturing = false;
    @Input() fingerName = '';
    @Input() progressClass = '';
    @Input() successAuth = false;
    intento = 1;
    step = 1;
    finger1: FingerModel = null;
    finger2: FingerModel = null;
    newAgent: RnecAgentModel;
    identityNumber = Number(this.bdbSessionStrgService.get(SessionStorageKeysEnum.IDENTITY_NUMBER));
    tempErrorAgentConexion: ReturnType<typeof setInterval>;
    intentosConexion = 1;

    constructor(
        private readonly bdbSessionStrgService: BdbSessionStrgService,
        private readonly googleTagManagerService: GoogleTagManagerService,
        private readonly redirectService: RedirectService,
        private readonly fingerprintUtil: FingerprintUtil,
        private readonly router: Router,
        private readonly eventsService: EventsService,
    ) {
        this.newAgent = new RnecAgentModel();
    }

    async ngOnInit() {
        logger.log('Start RNEC Component V2');
        const { fingerLeftHand, fingerRightHand } = this.fingerprintUtil.initializeFingerToCapture();
        this.finger1 = fingerLeftHand
        this.finger2 = fingerRightHand
        window.scrollTo(0, 0);

        this.googleTagManagerService.sendInfo(window.location.pathname, 'Autenticación RNEC')
    }

    async capture() {
        this.successFingerprint = false;
        switch (this.step) {
            case 1:
                this.renderFingerprintCapture(this.finger1, 'progress-first');
                logger.log('capturing first hand new...');
                return this.handleCaptureHand(this.finger1, '1', this.setNextFingerprintLayout.bind(this));
            case 2:
                this.optionQuit();
                break;
            case 3:
                this.renderFingerprintCapture(this.finger2, 'progress-second');
                logger.log('capturing second hand new...');
                return this.handleCaptureHand(this.finger2, '2', this.setValidationFingerprintLayout.bind(this));
            case 4:
                this.successAuth = true;
                await this.validateFingers();
                break;
        }
    }

    async validateFingers(): Promise<void> {
        try {
            const result = await this.newAgent.startValidateFingerprint(this.identityNumber);

            logger.debug('Result from validate fingers:', result);

            const eventResult = await this.newAgent.reportEvent(result, this.eventsService);
            logger.log('The result from event validate --->', eventResult);

            if (String(result.Error) === '400') {
                this.errorAgentConexion.openDialogue();
                this.tempErrorAgentConexion = setInterval(this.setErrorConexionModalInfo.bind(this), 4000);
                return;
            }

            if (result.resultado === 'HIT') {
                this.bdbSessionStrgService.save(SessionStorageKeysEnum.CANDIDATE, JSON.stringify(result.candidato));
                this.validateReportAuthenticationRnec(eventResult);
                return;
            }

            // if (result.descripcionError.includes('Ha superado el numero de intentos por un dia')) {
            //     this.redirectService.redirectToError(ErrorCode.ATTEMPTS_PER_DAY_EXCEEDED, 'v2');
            //     return;
            // }

            // if (result.resultado === 'NOHIT') {
            //     this.modalFunctionYes = this.closeModal;
            //     this.errorModal.openErrorModal(ErrorCode.NO_HIT);
            //     return;
            // }

            this.step = 1;
            this.setStepAndShowErrorModal();
        } catch (e) {
            logger.error('ERROR -->', e);
        }
    }

    validateReportAuthenticationRnec(responseFromReport): void {
        const mustValidateExpDate = ['4'].includes(this.bdbSessionStrgService.get('mediumType')) &&
            [401].includes(responseFromReport.status);
        if (responseFromReport.status === 200) {
            const accessToken: any = responseFromReport.body.accessToken
            this.saveInfoFromResponseAndRedirect(accessToken);
        } else if (mustValidateExpDate) {
            this.checkExpDateTries();
        } else {
            this.step = 1;
            this.setStepAndShowErrorModal();
        }
    }

    private saveInfoFromResponseAndRedirect(accessToken: string) {
        this.bdbSessionStrgService.delete(RNECEventEnum.EXPDATE);
        this.bdbSessionStrgService.save(SessionStorageKeysEnum.ACCESS_TOKEN, accessToken);
        const mediumType = this.bdbSessionStrgService.get(SessionStorageKeysEnum.MEDIUM_TYPE);
        const mediumTypesSecondFactor = environment.mediumTypesSecondFactor.split(',');
        const isMediumTypeForSecondFactor = mediumTypesSecondFactor.includes(mediumType);
        const customerState = this.bdbSessionStrgService.get(SessionStorageKeysEnum.CUSTOMER_STATE);
        const isClient = customerState === 'ACTIVE';
        const allowedSecondFactorConditions = this.bdbSessionStrgService.get(SessionStorageKeysEnum.SECOND_FACTOR);
        const actualConditionsSecondFactor = environment.useSecondFactor && isMediumTypeForSecondFactor && isClient;
        if (allowedSecondFactorConditions || actualConditionsSecondFactor) {
            this.router.navigate(['second-factor-selector']);
        } else {
            this.redirectService.redirectFromAuthentication();
        }
    }

    private checkExpDateTries(): void {
        let userTries = +this.bdbSessionStrgService.get(RNECEventEnum.EXPDATE) || 1;

        if (userTries >= environment.expDateMaxAttempts) {
            this.bdbSessionStrgService.delete(RNECEventEnum.EXPDATE);
            // this.redirectService.redirectToError(ErrorCode.EXPDATE_MISMATCH, 'v2');
            this.router.navigate(['/']);
        } else {
            userTries++;
            this.bdbSessionStrgService.save(RNECEventEnum.EXPDATE, `${userTries}`);
            this.router.navigate(['/expedition-date']);
        }
    }

    private setStepAndShowErrorModal() {
        this.bdbSessionStrgService.delete(RNECEventEnum.EXPDATE);
        this.successAuth = false;
        this.setErrorModalInfo();
    }

    optionQuit() {
        this.redirectService.quit();
    }

    async handleCaptureHand(finger: FingerModel, hand: string, onSuccess: Function) {
        const result = await this.captureHand(finger, hand);
        await this.newAgent.reportEvent(result, this.eventsService);
        const response: IDataCaptureFingerprint = result.data;

        if (!response.Error) {
            this.intento = 1;
            onSuccess();
            return;
        }

        if (response.Error === '400') {
            this.errorAgentConexion.openDialogue();
            this.tempErrorAgentConexion = setInterval(this.setErrorConexionModalInfo.bind(this), 4000);
            return;
        }

        const CAPTURE_TIME_EXCEEDED = '-19'

        if (response.Error === CAPTURE_TIME_EXCEEDED) {
            this.modalFunctionYes = this.closeModal;
            this.errorModal.openErrorModal(ErrorCode.CAPTURE_TIME_EXCEEDED)
            return;
        }

        // const INVALID_FINGER = '-75'

        // if (response.Error === INVALID_FINGER) {
        //     this.modalFunctionYes = this.closeModal;
        //     this.errorModal.openErrorModal(ErrorCode.NO_HIT);
        //     return;
        // }

        this.successAuth = false;
        this.setErrorModalInfo();
    }

    async captureHand(finger: FingerModel, hand: string): Promise<IResponseAgent> {
        try {
            const response = await this.newAgent.startCapturingFingerprint(finger, this.identityNumber, hand);
            logger.log('Response capturing finger:', response);
            return response;
        } catch (e) {
            logger.error('Error capturing finger:', { ...e });
            this.bdbSessionStrgService.save('captorStatus', 'off');
            this.capturing = false;
            this.fingerNameClass = '';
            // this.redirectService.redirectToError(ErrorCode.NO_FINGERPRINTS_CAPTURED, 'v2');
            this.setErrorAgentModalInfo()
            this.newAgent.reportEvent(e, this.eventsService)
        }
    }

    renderFingerprintCapture(finger: FingerModel, progressClass: any) {
        logger.log('About to capture finger:', finger);

        this.fingerNameClass = 'finger' + finger.id;
        this.fingerName = `${finger.name} ${finger.hand}`;
        this.progressClass = progressClass;
        this.capturing = true;
    }

    private setNextFingerprintLayout(): void {
        this.successfulCapturing('Siguiente huella ›');
        this.step = 3;
    }

    private setValidationFingerprintLayout(): void {
        this.successfulCapturing('Continuar ›');
        this.step = 4;
    }

    private successfulCapturing(buttonText: string) {
        this.fingerNameClass = '';
        this.capturing = false;
        this.successFingerprint = true;
        this.buttonText = buttonText;
    }

    closeModal(): void {
        const statusCaptor = this.bdbSessionStrgService.get('captorStatus');

        if (statusCaptor && statusCaptor === 'off') {
            this.callModalLoading();
            this.bdbSessionStrgService.delete('captorStatus');
            window.open(`olimpiait://reconoser?security='https'`);
            setTimeout(() => {
                this.loaderBdb.nativeElement.closeLoader();
                location.reload();
            }, 8000);
            return;
        }

        if (this.intento === 3) {
            this.redirectService.redirectToError(ErrorCode.ATTEMPTS_EXCEEDED, 'v2');
        } else {
            this.intento++;
            this.capture();
        }
    }

    private async setErrorConexionModalInfo() {
        const data = await this.newAgent.getCaptorVersion();

        if (data.Error) {
            this.intentosConexion++
            if (this.intentosConexion > 10) {
                clearInterval(this.tempErrorAgentConexion);
                this.errorAgentConexion.closeDialogue();
                this.redirectService.redirectToError(NewServiceErrorEnum.CONNECTION_ERROR);
            }
        } else {
            clearInterval(this.tempErrorAgentConexion);
            this.errorAgentConexion.closeDialogue();
            this.intentosConexion = 1;
            location.reload();
        }
    }

    private setErrorAgentModalInfo() {
        this.modalFunctionYes = this.closeModal;
        this.setModalTitles(
            'Biométrico desactivado',
            'Activa el Biométrico para poder tomar la captura de las huellas'
        );
        this.modalBdb.nativeElement.optionsButtons = [
            { id: '0', value: 'Activar' }
        ];
        this.modalBdb.nativeElement.openAlert();
    }

    private setErrorModalInfo() {
        this.modalFunctionYes = this.closeModal;
        this.setModalTitles(
            'Falló el servicio de autenticación',
            '¿Desea volver a intentar?'
        );
        this.modalBdb.nativeElement.optionsButtons = [
            { id: '0', value: 'Si' },
            { id: '1', value: 'No' }
        ];
        this.modalBdb.nativeElement.openAlert();
    }

    private callModalLoading() {
        this.loaderBdb.nativeElement.openLoader();
    }

    setModalTitles(title: string, subtitle: string) {
        this.modalBdb.nativeElement.titleModal = title
        this.modalBdb.nativeElement.subTitle = subtitle
    }

    actionButtomModalBdb(evento: CustomEvent) {
        if (evento.detail.id === '0') {
            this.modalFunctionYes();
        } else {
            this.optionQuit();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/authentication-rnec-v2/authentication-rnec-v2.component.ts